import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'kamino',
});

export const cloneRouteRef = createSubRouteRef({
  id: 'kamino/clone',
  parent: rootRouteRef,
  path: '/clone',
});

export const templatesRouteRef = createSubRouteRef({
  id: 'kamino/templates',
  parent: rootRouteRef,
  path: '/templates',
});

export const operationsRouteRef = createSubRouteRef({
  id: 'kamino/operations',
  parent: rootRouteRef,
  path: '/operations',
});

export const operationDetailRouteRef = createSubRouteRef({
  id: 'kamino/operations/detail',
  parent: rootRouteRef,
  path: '/operations/:operationId',
});
